import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

// Importaciones de interfaces.
import { IActivation } from '../../interfaces/activation.interface';

// Importaciones de entornos.
import { environment } from '../../../environments/environment';

/**
 * Componente de diálogo para la activación de elementos.
 *
 * Este componente proporciona una interfaz modal para gestionar la activación de elementos en la aplicación.
 * Permite visualizar información relevante y confirmar acciones de activación.
 */
@Component({
  selector: 'app-activation-dialog',
  templateUrl: './activation-dialog.component.html',
  standalone: false,
})
export class ActivationDialogComponent {
  /**
   * Referencia al diálogo activo.
   *
   * Esta propiedad almacena la referencia del diálogo utilizando
   * `MatDialogRef`, lo que permite controlar el comportamiento
   * del diálogo, como cerrarlo y pasar datos de retorno.
   */
  readonly dialogRef: MatDialogRef<ActivationDialogComponent> = inject(
    MatDialogRef<ActivationDialogComponent>
  );

  /**
   * Datos de activación.
   *
   * Esta propiedad almacena los datos de la activación que se
   * pasan al componente a través de `MAT_DIALOG_DATA`.
   * Representa la información necesaria para gestionar la
   * activación dentro del diálogo.
   */
  readonly activation: IActivation = inject<IActivation>(MAT_DIALOG_DATA);

  /**
   * Servicio de MatSnackBar utilizado para mostrar notificaciones emergentes en la interfaz de usuario.
   * Se inyecta utilizando la función `inject` de Angular.
   */
  private snackBar: MatSnackBar = inject<MatSnackBar>(MatSnackBar);

  /**
   * Copia el texto proporcionado al portapapeles de manera asíncrona.
   *
   * @param text - Texto que se desea copiar al portapapeles.
   */
  async copyToClipboard(text: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(text);
      this.snackBar.open(`El texto ${text} fue copiado al portapapeles.`, '', {
        duration: 5000,
      });
    } catch (error: any) {
      if (!environment.production) {
        console.error('Error al copiar el texto al portapapeles:', error);
      }
    }
  }
}
